import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { Button, glyphs as Glyphs } from '@treelab/panda';

import { TypographyStyle, TypographyWeight } from '../../../panda';

import { Typography } from '../../Typography';
import { Modal } from '../';
import { HeaderContainer, BtnContainer, ModalContainer } from './styled';

interface IProps extends WrappedComponentProps {
  onClose: () => void;
  onCloseWithSave: () => void;
  onCloseWithoutSave: () => void;
}

const ExitModal: React.FC<IProps> = ({
  onClose,
  onCloseWithSave,
  onCloseWithoutSave,
  intl: { formatMessage },
}) => (
  <Modal
    onClose={onClose}
    style={{
      top: '94px',
      left: 'calc(100% - 170px)',
      height: '138px',
      width: '272px',
      padding: '14px 24px 16px',
    }}
    suppressMask
  >
    <ModalContainer>
      <HeaderContainer>
        <Typography type={TypographyStyle.P1} weight={TypographyWeight.Medium}>
          {formatMessage({ id: 'core.warning.unsaved.header' })}
        </Typography>
        <Button
          icon={Glyphs.CLOSE_V2}
          itemSize="small"
          buttonType="text"
          type="button"
          onClick={onClose}
        />
      </HeaderContainer>
      <Typography type={TypographyStyle.P2} style={{ whiteSpace: 'initial' }}>
        {formatMessage({ id: 'core.warning.unsaved.body' })}
      </Typography>
      <BtnContainer>
        <Button
          tabIndex={2}
          buttonType="outline"
          onClick={onCloseWithoutSave}
          css={'margin-right: 20px'}
        >
          {formatMessage({ id: 'core.warning.unsaved.close' })}
        </Button>
        <Button tabIndex={1} onClick={onCloseWithSave}>
          {formatMessage({ id: 'core.warning.unsaved.save' })}
        </Button>
      </BtnContainer>
    </ModalContainer>
  </Modal>
);

export default injectIntl(ExitModal);
